































import { computed, defineComponent } from "@vue/composition-api";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import LoadingThumbnail from "@/components/ContentLoadingPlaceholders/components/LoadingThumbnail.vue";
import PayeeInfoPreview from "./PayeeInfoPreview.vue";

export interface FormFileData {
  data: FileList | FileData | null;
}

export default defineComponent({
  name: "PayeeInfoInputFile",
  components: { LoadingThumbnail, BaseInputFile, PayeeInfoPreview, BaseButton, BaseIcon },
  props: {
    value: { type: Object as () => FormFileData, readonly: true },
    uploadingProgress: { type: Number, readonly: true },
    loading: { type: Boolean, readonly: true, default: false },
    accept: { type: Array as () => string[], default: () => ["image"] },
    iconSize: { type: String, default: "14" },
  },
  setup(props) {
    const inputSrc = computed(() => {
      if (!props.value || !props.value.data) return "";
      return props.value.data instanceof FileList
        ? URL.createObjectURL(props.value.data[0])
        : props.value.data.contentType.includes("image")
        ? MediaFilesController.getImageThumbnail(props.value.data.urlPart, 122)
        : "";
    });

    const name = computed(() => {
      if (!props.value || !props.value.data) return "";
      return props.value.data instanceof FileList ? props.value.data[0].name : props.value.data.metadata.filename;
    });

    return { inputSrc, name };
  },
});
